export const addListener = (callback) => {
    document.addEventListener('keydown', callback);
}

export const removeListener = (callback) => {
    document.removeEventListener('keydown', callback);
}